{
  "navbar": {
    "logout": "Déconnexion"
  }
}
